var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LightDimUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h4v10h-4V59zm15.93-4.44L52 61.63l2.82-2.83-7.07-7.07-2.82 2.83zM7.17 58.8L10 61.63l7.07-7.07-2.83-2.83-7.07 7.07zM10 36H0v4h10v-4zm21.34 13.92A11.87 11.87 0 0123.55 47a11.997 11.997 0 01-1.84-2c-.1-.14-.21-.28-.31-.43a11.618 11.618 0 01-1-1.77A11.86 11.86 0 0123 29.5a12.09 12.09 0 014-2.59V18h8v5.37l4-4.2v-2.26a8 8 0 00-16 0v7.56a15.82 15.82 0 00-5.85 20.7c.313.634.67 1.246 1.07 1.83a15.89 15.89 0 0026.23 0h-5.33a11.86 11.86 0 01-7.78 2.92zm7-6.92H48V18L24 43h14.34zM52 18v25h24L52 18z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Light_dim_up_down.18477cf8.svg";
export { SvgA3LightDimUpDown as ReactComponent };